import { LawTopicEnum } from '@/types/generated'

export const lawTopicsEN: Record<string, string> = {
  [LawTopicEnum.AGB]: 'Terms & Conditions',
  [LawTopicEnum.ABFINDUNG]: 'Severance Pay',
  [LawTopicEnum.ABMAHNUNG]: 'Formal Warning',
  [LawTopicEnum.ABMAHNUNG_WETTBEWERBSRECHT]: 'Competition Law Warning',
  [LawTopicEnum.ABSCHIEBUNGSHAFT]: 'Deportation Detention',
  [LawTopicEnum.ABSCHLUSSARBEIT]: 'Thesis',
  [LawTopicEnum.ABSTANDSREGELUNG_NICHT_EINGEHALTEN]: 'Distance Regulation Violation',
  [LawTopicEnum.ACCOUNT_HACKING]: 'Account Hacking',
  [LawTopicEnum.ALLGEMEIN]: 'General',
  [LawTopicEnum['ALLGEMEINES_PRÜFUNGSRECHT']]: 'General Examination Law',
  [LawTopicEnum.ANDERES]: 'Other',
  [LawTopicEnum.ARBEITSAMT_ALG_SPERRZEIT]: 'Employment Office / Unemployment Benefits',
  [LawTopicEnum.ARBEITSUNFALL]: 'Work Accident',
  [LawTopicEnum.ARBEITSVERTRAG]: 'Employment Contract',
  [LawTopicEnum.ARBEITSZEUGNIS]: 'Employment Reference',
  [LawTopicEnum.AUFBAU_COMPLIANCESYSTEM]: 'Compliance System Setup',
  [LawTopicEnum.AUFENTHALTSERLAUBNIS]: 'Residence Permit',
  [LawTopicEnum.AUFHEBUNGSVERTRAG]: 'Termination Agreement',
  [LawTopicEnum.AUFTRAGSDATENVERARBEITUNG]: 'Data Processing Agreement',
  [LawTopicEnum.AUSEINANDERSETZUNG_ERBENGEMEINSCHAFT]: 'Estate Community Dispute',
  [LawTopicEnum['AUSKUNFT_PRÜFEN']]: 'Review Information Request',
  [LawTopicEnum.AUSWEISUNG]: 'Expulsion',
  [LawTopicEnum.AUTOKAUF]: 'Car Purchase',
  [LawTopicEnum['BANKKONTO_LEERGERÄUMT']]: 'Bank Account Emptied',
  [LawTopicEnum.BANKRECHT]: 'Banking Law',
  [LawTopicEnum.BAUMANGEL]: 'Construction Defect',
  [LawTopicEnum.BAUVERTRAG]: 'Construction Contract',
  [LawTopicEnum.BEHANDLUNGSFEHLER_ALLGEMEIN]: 'Medical Malpractice (General)',
  [LawTopicEnum['BEHANDLUNGSFEHLER_QUERSCHNITTSLÄHMUNG']]: 'Medical Malpractice (Paraplegia)',
  [LawTopicEnum.BEHANDLUNGSFEHLER_SCHLAGANFALL]: 'Medical Malpractice (Stroke)',
  [LawTopicEnum.BEISSVORFALL]: 'Biting Incident',
  [LawTopicEnum.BERATUNG_ZU_ERBFALL]: 'Inheritance Consultation',
  [LawTopicEnum.BESCHLAGNAHME_ALLGEMEIN]: 'Seizure (General)',
  [LawTopicEnum['BESCHLAGNAHME_TIERQUÄLEREI']]: 'Seizure (Animal Cruelty)',
  [LawTopicEnum.BETREUUNGSRECHT]: 'Guardianship Law',
  [LawTopicEnum.BETRUG_GELDANLAGE]: 'Investment Fraud',
  [LawTopicEnum['BETÄUBUNGSMITTEL']]: 'Narcotics',
  [LawTopicEnum.BURGSCHILD_INKASSO]: 'Burgschild Debt Collection',
  [LawTopicEnum.BUSSGELDBESCHEID]: 'Fine Notice',
  [LawTopicEnum['BÜRGERGELD']]: "Citizen's Allowance",
  [LawTopicEnum.COACHING]: 'Coaching',
  [LawTopicEnum.DATENSCHUTZ]: 'Data Protection',
  [LawTopicEnum.DATENSCHUTZ_SCHADENSERSATZ]: 'Data Protection Damages',
  [LawTopicEnum.DATENSCHUTZVERSTOSS]: 'Data Protection Violation',
  [LawTopicEnum.DISKRIMINIERUNG]: 'Discrimination',
  [LawTopicEnum.DOMAINS]: 'Domains',
  [LawTopicEnum.EHEVERTRAG]: 'Prenuptial Agreement',
  [LawTopicEnum.EIGENTUMSDELIKTE]: 'Property Offenses',
  [LawTopicEnum['EINBÜRGERUNG']]: 'Naturalization',
  [LawTopicEnum.EINGRUPPIERUNG]: 'Job Classification',
  [LawTopicEnum.EINREISESPERRE]: 'Entry Ban',
  [LawTopicEnum['EINTRAG_LÖSCHEN']]: 'Delete Entry',
  [LawTopicEnum.ERBAUSEINANDERSETZUNG]: 'Estate Distribution',
  [LawTopicEnum.ERBAUSSCHLAGUNG]: 'Inheritance Renunciation',
  [LawTopicEnum.ERBEN_SCHENKEN]: 'Inheritance / Gifts',
  [LawTopicEnum.ERBENGEMEINSCHAFT]: 'Community of Heirs',
  [LawTopicEnum.ERBSCHEIN]: 'Certificate of Inheritance',
  [LawTopicEnum.ERBSCHEINSANTRAG]: 'Certificate of Inheritance Application',
  [LawTopicEnum.ERBVERTRAG]: 'Inheritance Contract',
  [LawTopicEnum.EXMATRIKULATION]: 'University Expulsion',
  [LawTopicEnum['FAHREN_OHNE_FÜHRERSCHEIN']]: 'Driving Without a License',
  [LawTopicEnum.FAHREN_UNTER_ALKOHOL_____DROGENEINFLUSS]: 'Driving Under the Influence',
  [LawTopicEnum.FAHRER_____UNFALLFLUCHT]: 'Hit and Run',
  [LawTopicEnum['FAHRVERBOT___FÜHRERSCHEINENTZUG']]: 'Driving Ban / License Revocation',
  [LawTopicEnum.FALSCHAUSSAGE__MEINEID]: 'False Testimony / Perjury',
  [LawTopicEnum.FAMILIE_VORSORGE]: 'Family Provision',
  [LawTopicEnum['FORDERUNG_LÖSCHEN']]: 'Delete Claim',
  [LawTopicEnum.GEBURTSFEHLER]: 'Birth Defect',
  [LawTopicEnum.GEBURTSFEHLER_MUTTER]: 'Birth Defect (Mother)',
  [LawTopicEnum['GESCHWINDIGKEITSÜBERSCHREITUNG']]: 'Speeding',
  [LawTopicEnum.GESETZLICHE_ERBFOLGE]: 'Legal Succession',
  [LawTopicEnum.GEWERBLICHER_RECHTSSCHUTZ]: 'Industrial Property Rights',
  [LawTopicEnum.GRUNDSCHULD]: 'Land Charge',
  [LawTopicEnum['GRÜNDUNG']]: 'Company Formation',
  [LawTopicEnum.HANDY_AM_STEUER]: 'Phone While Driving',
  [LawTopicEnum.HAUSKAUF]: 'House Purchase',
  [LawTopicEnum['HÄRTEFALLANTRAG']]: 'Hardship Application',
  [LawTopicEnum.IMMOBILIEN]: 'Real Estate',
  [LawTopicEnum['IMMOBILIENÜBERTRAGUNG']]: 'Real Estate Transfer',
  [LawTopicEnum['KAUFVERTRAGSPRÜFUNG']]: 'Purchase Contract Review',
  [LawTopicEnum['KÖRPERVERLETZUNG']]: 'Bodily Harm',
  [LawTopicEnum['KÜNDIGUNG']]: 'Termination',
  [LawTopicEnum.LOHNZAHLUNG]: 'Wage Payment',
  [LawTopicEnum.MAKLERANGELEGENHEIT]: 'Broker Matter',
  [LawTopicEnum.MARKENANMELDUNG]: 'Trademark Registration',
  [LawTopicEnum.MARKENVERTEIDIGUNG]: 'Trademark Defense',
  [LawTopicEnum['MARKENÜBERWACHUNG']]: 'Trademark Monitoring',
  [LawTopicEnum['MIETERHÖHUNG']]: 'Rent Increase',
  [LawTopicEnum.MIETKAUTION]: 'Rental Deposit',
  [LawTopicEnum.MIETMINDERUNG]: 'Rent Reduction',
  [LawTopicEnum.MIETVERTRAG]: 'Lease Agreement',
  [LawTopicEnum.MOBBING]: 'Workplace Bullying',
  [LawTopicEnum.NEBENKOSTENABRECHNUNG]: 'Utility Cost Statement',
  [LawTopicEnum.NIEDERLASSUNGSERLAUBNIS]: 'Settlement Permit',
  [LawTopicEnum.NUTZERBEWERTUNGEN_VERFASSER]: 'User Reviews (Author)',
  [LawTopicEnum['PATIENTENVERFÜGUNG_VORSORGEVOLLMACHT']]: 'Living Will / Power of Attorney',
  [LawTopicEnum.PERSONENVERWECHSELUNG]: 'Identity Mix-up',
  [LawTopicEnum.PFLEGE__KRANKENVERSICHERUNG]: 'Care / Health Insurance',
  [LawTopicEnum.PFLEGERECHT]: 'Care Law',
  [LawTopicEnum.PFLICHTTEIL]: 'Compulsory Share',
  [LawTopicEnum.PFLICHTTEIL_GELTENDMACHUNG]: 'Compulsory Share Claim',
  [LawTopicEnum.PFLICHTTEIL_ABWEHREN]: 'Compulsory Share Defense',
  [LawTopicEnum.PLAGIATSVORWURF]: 'Plagiarism Allegation',
  [LawTopicEnum.REMONSTRATION]: 'Remonstration',
  [LawTopicEnum.RENTE]: 'Pension',
  [LawTopicEnum.ROTLICHTVERSTOSS]: 'Red Light Violation',
  [LawTopicEnum['RÄUMUNGSKLAGE']]: 'Eviction Lawsuit',
  [LawTopicEnum.SCHADENSERSATZ]: 'Damages',
  [LawTopicEnum.SCHEIDUNG]: 'Divorce',
  [LawTopicEnum.SCHENKUNG]: 'Gift / Donation',
  [LawTopicEnum.SCHENKUNG_IMMOBILIE]: 'Real Estate Gift',
  [LawTopicEnum.SCHULPLATZ_EINKLAGEN]: 'Suing for School Place',
  [LawTopicEnum.SCHWERBEHINDERUNG]: 'Severe Disability',
  [LawTopicEnum.SEXUALDELIKT]: 'Sexual Offense',
  [LawTopicEnum.SOFTWARE_HARDWARE]: 'Software / Hardware',
  [LawTopicEnum.SONSTIGE_BEGLAUBIGUNG]: 'Other Certification',
  [LawTopicEnum.SORGERECHT_UND_UMGANGSRECHT]: 'Custody and Visitation Rights',
  [LawTopicEnum.TESTAMENT]: 'Will',
  [LawTopicEnum.TESTAMENT_ERBVERTRAG]: 'Will / Inheritance Contract',
  [LawTopicEnum.TIERKAUF]: 'Animal Purchase',
  [LawTopicEnum['TIERÄRZTLICHE_BEHANDLUNGSFEHLER']]: 'Veterinary Malpractice',
  [LawTopicEnum.TRENNUNG]: 'Separation',
  [LawTopicEnum.TUNING]: 'Tuning',
  [LawTopicEnum['TÄUSCHUNGSVERSUCH']]: 'Cheating Attempt',
  [LawTopicEnum['TÖTUNGSDELIKTE']]: 'Homicide',
  [LawTopicEnum['UNFALL_QUERSCHNITTSLÄHMUNG']]: 'Accident (Paraplegia)',
  [LawTopicEnum.UNFALL_MIT_PERSONENSCHADEN]: 'Accident with Personal Injury',
  [LawTopicEnum.UNTERHALT]: 'Maintenance / Alimony',
  [LawTopicEnum.UNTERNEHMEN]: 'Company',
  [LawTopicEnum['UNTERNEHMENSAUFLÖSUNG']]: 'Company Dissolution',
  [LawTopicEnum['UNTERNEHMENSGRÜNDUNG']]: 'Company Formation',
  [LawTopicEnum.UNTERNEHMENSKAUF]: 'Company Acquisition',
  [LawTopicEnum.URHEBERRECHT]: 'Copyright',
  [LawTopicEnum.URLAUB]: 'Vacation / Leave',
  [LawTopicEnum.VATERSCHAFTSANERKENNUNG]: 'Paternity Acknowledgment',
  [LawTopicEnum.VERERBEN]: 'Bequeathing',
  [LawTopicEnum.VERKEHRSUNFALL]: 'Traffic Accident',
  [LawTopicEnum['VERMÖGENSAUSEINANDERSETZUNG']]: 'Asset Division',
  [LawTopicEnum['VERMÖGENSDELIKTE']]: 'Property Crimes',
  [LawTopicEnum.VERSTOSS_GEGEN_DIE_ANSCHNALLPFLICHT]: 'Seatbelt Violation',
  [LawTopicEnum['VERTRAGSPRÜFUNG']]: 'Contract Review',
  [LawTopicEnum.VERTRAGSRECHT]: 'Contract Law',
  [LawTopicEnum.VISUM]: 'Visa',
  [LawTopicEnum['VORFÄLLIGKEITSENTSCHÄDIGUNG']]: 'Early Repayment Penalty',
  [LawTopicEnum.VORSORGE]: 'Provision',
  [LawTopicEnum['VORSORGEVOLLMACHT_PATIENTENVERFÜGUNG']]: 'Power of Attorney / Living Will',
  [LawTopicEnum.WAFFENDELIKTE]: 'Weapons Offenses',
  [LawTopicEnum.WETTBEWERBSRECHT]: 'Competition Law',
  [LawTopicEnum.WIDERRUFSRECHTE]: 'Right of Withdrawal',
  [LawTopicEnum.WIDERSPRUCH__KLAGE]: 'Objection / Lawsuit',
  [LawTopicEnum.WUCHERZINSEN_DARLEHEN]: 'Usurious Loan Interest',
  [LawTopicEnum.ZUGEWINNAUSGLEICH]: 'Equalization of Gains',
  [LawTopicEnum.ZWEIRADUNFALL]: 'Two-wheeled Vehicle Accident',
  [LawTopicEnum.UNBEZAHLTE_RECHNUNGEN]: 'Unpaid Invoices',
  [LawTopicEnum['UNERLAUBTES_GLÜCKSSPIEL']]: 'Illegal Gambling',
  [LawTopicEnum['ÜBERSTUNDEN']]: 'Overtime',
  [LawTopicEnum['ÜBERTRAGUNG_ZU_LEBZEITEN']]: 'Inter Vivos Transfer'
}

export const lawTopicsFR: Record<string, string> = {
  [LawTopicEnum['KÜNDIGUNG']]: 'Rupture du contrat de travail',
  [LawTopicEnum.ABFINDUNG]: 'Indemnité de rupture',
  [LawTopicEnum.AUFHEBUNGSVERTRAG]: 'Rupture conventionnelle',
  [LawTopicEnum.ARBEITSZEUGNIS]: 'Certificat de travail',
  [LawTopicEnum.ABMAHNUNG]: 'Sanction disciplinaire / avertissement',
  [LawTopicEnum.URLAUB]: 'Congés payés',
  [LawTopicEnum.ARBEITSVERTRAG]: 'Contrat de travail',
  [LawTopicEnum.ARBEITSUNFALL]: 'Accident du travail',
  [LawTopicEnum['ÜBERSTUNDEN']]: 'Heures supplémentaires',
  [LawTopicEnum.LOHNZAHLUNG]: 'Paiement du salaire',
  [LawTopicEnum.MOBBING]: 'Harcèlement moral',
  [LawTopicEnum.DISKRIMINIERUNG]: 'Discrimination',
  [LawTopicEnum.EINGRUPPIERUNG]: 'Classification / coefficient / convention collective',
  [LawTopicEnum.ARBEITSAMT_ALG_SPERRZEIT]:
    "France Travail / allocations chômage / délai ou sanction d'indemnisation",
  [LawTopicEnum.ANDERES]: 'Autre'
}
